import { Component, OnInit } from "@angular/core";

@Component({
  selector: "mis-employee-web-exp-meeting-card",
  templateUrl: "./meeting-card.component.html",
  styleUrls: ["./meeting-card.component.scss"]
})
export class MeetingCardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
